/** @format */

export enum TimerManagerSubscribeEventEnum {
    createTimer = 'MANAGER_SUBSCRIBE_TIMER_CREATE',
    startTimer = 'MANAGER_SUBSCRIBE_TIMER_START',
    startTimerWithDelay = 'MANAGER_SUBSCRIBE_TIMER_DELAYED_START',
    stopTimer = 'MANAGER_SUBSCRIBE_TIMER_STOP',
    removeTimer = 'MANAGER_SUBSCRIBE_TIMER_REMOVE',
    stopTimersInNamespace = 'MANAGER_SUBSCRIBE_TIMERS_NAMESPACE_STOP',
    removeTimersInNamespace = 'MANAGER_SUBSCRIBE_TIMERS_NAMESPACE_REMOVE',
    stopTimersGlobally = 'MANAGER_SUBSCRIBE_TIMERS_GLOBAL_STOP',
    removeTimersGlobally = 'MANAGER_SUBSCRIBE_TIMERS_GLOBAL_REMOVE',
    checkTimerExists = 'MANAGER_SUBSCRIBE_TIMER_EXISTS',
    checkTimerRunning = 'MANAGER_SUBSCRIBE_TIMER_RUNNING',
    checkTimerExistsAndRunning = 'MANAGER_SUBSCRIBE_TIMER_EXISTS_RUNNING',
    accessMethodOnTimer = 'MANAGER_SUBSCRIBE_TIMER_ACCESS_METHOD_RESPONSE',
    managerRemoveReference = 'MANAGER_SUBSCRIBE_TIMER_REMOVE_REFERENCE',
    // countTimersInNamespace = 'MANAGER_SUBSCRIBE_TIMERS_NAMESPACE_COUNT',
    // countTimersGlobally = 'MANAGER_SUBSCRIBE_TIMERS_GLOBAL_COUNT',
}
